import { useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { useInView } from '@helpers/useIntersectionObserver'

// Simplified, brand-colored logomarks — small inline SVGs for icons
// FontAwesome doesn't cover.
const VercelIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path fill="#000" d="M12 2 22 20 2 20Z" />
  </svg>
)
const TypeScriptIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <rect width="24" height="24" rx="4" fill="#3178C6" />
    <text x="12" y="17" textAnchor="middle" fontSize="11" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">TS</text>
  </svg>
)
const NextIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <circle cx="12" cy="12" r="12" fill="#000" />
    <text x="12" y="16.5" textAnchor="middle" fontSize="12" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">N</text>
  </svg>
)
const TailwindIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path fill="#38BDF8" d="M12 6c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.31.74 1.91 1.35.98 1 2.12 2.15 4.59 2.15 2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.31-.74-1.91-1.35C15.61 7.15 14.47 6 12 6Z" />
    <path fill="#38BDF8" d="M7 12c-2.67 0-4.33 1.33-5 4 1-1.33 2.17-1.83 3.5-1.5.76.19 1.31.74 1.91 1.35.98 1 2.12 2.15 4.59 2.15 2.67 0 4.33-1.33 5-4-1 1.33-2.17 1.83-3.5 1.5-.76-.19-1.31-.74-1.91-1.35C10.61 13.15 9.47 12 7 12Z" />
  </svg>
)
const PrismaIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path fill="#2D3748" d="M11.3 2.3a1 1 0 0 1 1.4 0l8.5 16.2a1 1 0 0 1-.9 1.5H3.7a1 1 0 0 1-.9-1.5Z" />
  </svg>
)
const FigmaIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <path fill="#F24E1E" d="M8 1h4v6H8a3 3 0 1 1 0-6Z" />
    <path fill="#FF7262" d="M12 1h4a3 3 0 1 1 0 6h-4Z" />
    <path fill="#A259FF" d="M12 7h4a3 3 0 1 1-3 3V7Z" />
    <path fill="#1ABCFE" d="M8 10a3 3 0 1 1 4 2.83V13a3 3 0 1 1-4-2.83Z" />
    <path fill="#0ACF83" d="M8 13a3 3 0 1 1 4 2.83V22a3 3 0 1 1-4-6.17Z" />
  </svg>
)
const DotNetIcon = () => (
  <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
    <rect width="24" height="24" rx="4" fill="#512BD4" />
    <text x="12" y="16" textAnchor="middle" fontSize="8" fontWeight="700" fill="#fff" fontFamily="Arial, sans-serif">.NET</text>
  </svg>
)
const HTML      = () => <i className="fa-brands fa-html5"                    style={{ color: '#E34F26', fontSize: '18px' }} aria-hidden="true" />
const ReactJs   = () => <i className="fa-brands fa-react"                    style={{ color: '#61DAFB', fontSize: '18px' }} aria-hidden="true" />
const Vite      = () => <i className="devicon-vite-original"                 style={{ color: '#646CFF', fontSize: '18px' }} aria-hidden="true" />
const AspDotNet = () => <i className="devicon-dot-net-plain"                 style={{ color: '#512BD4', fontSize: '18px' }} aria-hidden="true" />
const NextJs    = () => <i className="devicon-nextjs-original-wordmark"      style={{ color: '#000000', fontSize: '16px' }} aria-hidden="true" />
const AngularJs = () => <i className="fa-brands fa-angular"                  style={{ color: '#DD0031', fontSize: '18px' }} aria-hidden="true" />
const PHP       = () => <i className="fa-brands fa-php"                      style={{ color: '#777BB4', fontSize: '18px' }} aria-hidden="true" />
const NodeJs    = () => <i className="fa-brands fa-node"                     style={{ color: '#339933', fontSize: '18px' }} aria-hidden="true" />
const ExpressJs = () => <i className="devicon-express-original"              style={{ color: '#000000', fontSize: '18px' }} aria-hidden="true" />
const CSharp    = () => <i className="devicon-csharp-plain"                  style={{ color: '#239120', fontSize: '18px' }} aria-hidden="true" />
const Wordpress = () => <i className="fa-brands fa-wordpress"                style={{ color: '#21759B', fontSize: '18px' }} aria-hidden="true" />
const MySQL     = () => <i className="devicon-mysql-original"                style={{ color: '#4479A1', fontSize: '18px' }} aria-hidden="true" />
const PostgreSQL= () => <i className="devicon-postgresql-plain"              style={{ color: '#336791', fontSize: '18px' }} aria-hidden="true" />
const AWS       = () => <i className="fa-brands fa-aws"                      style={{ color: '#FF9900', fontSize: '18px' }} aria-hidden="true" />
const AzureSQL  = () => <i className="devicon-azure-plain"                   style={{ color: '#0078D4', fontSize: '18px' }} aria-hidden="true" />
const GCP       = () => <i className="devicon-googlecloud-plain"             style={{ color: '#4285F4', fontSize: '18px' }} aria-hidden="true" />
const Android   = () => <i className="fa-brands fa-android"                  style={{ color: '#3DDC84', fontSize: '18px' }} aria-hidden="true" />
const Flutter   = () => <i className="fa-brands fa-flutter"                  style={{ color: '#02569B', fontSize: '18px' }} aria-hidden="true" />
const Nginx     = () => <i className="devicon-nginx-original"                style={{ color: '#009900', fontSize: '18px' }} aria-hidden="true" />
const GIT       = () => <i className="fa-brands fa-git"                      style={{ color: '#F05032', fontSize: '18px' }} aria-hidden="true" />
const VSCode    = () => <i className="devicon-vscode-plain"                  style={{ color: '#007ACC', fontSize: '18px' }} aria-hidden="true" />
const Postman   = () => <i className="devicon-postman-plain"                 style={{ color: '#FF6C37', fontSize: '18px' }} aria-hidden="true" />
const Python    = () => <i className="fa-brands fa-python"                   style={{ color: '#3776AB', fontSize: '18px' }} aria-hidden="true" />
const ChatGPT   = () => <i className="fa-brands fa-openai"                    style={{ color: '#412991', fontSize: '18px' }} aria-hidden="true" />
const ClaudeAI  = () => <i className="fa-brands fa-claude"                   style={{ color: '#D97757', fontSize: '18px' }} aria-hidden="true" />
// 7 columns x 4 rows — null = empty cell. Tapered shape: row 1 & 4 only
// populate columns 2-4 (0-indexed), row 2 & 3 populate all 7 columns.
// 20 icons total — placeholders, swap anytime.
const GRID_ROWS = [
  [null,        null,       { Icon: ReactJs }, { Icon:MySQL  },      { Icon:AWS  },      null,       null      ],
  [{ Icon:Nginx  }, { Icon:ExpressJs  },  { Icon:PHP  },{ Icon:VSCode  },  { Icon:Wordpress  }, { Icon:Postman  }, { Icon:Python  }],
  [{ Icon:Flutter  }, { Icon:Android  }, { Icon:AngularJs  }, { Icon: HTML }, { Icon:ChatGPT  }, { Icon:NodeJs  }, { Icon:AzureSQL  }],
  [{ Icon:CSharp  }, { Icon: DotNetIcon },  { Icon:PostgreSQL  },{ Icon:ClaudeAI  }, { Icon: AspDotNet }, { Icon: Vite }, { Icon: NextJs }],
  [null,null,{ Icon:GCP  },  { Icon:AzureSQL  },{ Icon:GIT  },   null,       null      ],
]

// Column 0/6 = heaviest blur, column 1/5 = lighter blur, 2-3-4 = sharp.
const COL_BLUR_TIER = ['edge', 'mid', 'clear', 'clear', 'clear', 'mid', 'edge']

// Each row moves at a slightly different fraction of the scroll shift —
// gives a layered feel instead of one flat block sliding.
const ROW_MULTIPLIER = [0.5, 1, 1, 0.5]

const SHIFT_MAX = 20
const SHIFT_STEP = 0.6
const SETTLE_DELAY = 200

export default function StackServices() {
  // const sectionRef = useRef(null)
   const [sectionRef, inView] = useInView({ threshold: 0.2 })
  const lastScrollY = useRef(0)
  const settleTimer = useRef(null)
  // const [inView, setInView] = useState(false)
  const [shift, setShift] = useState(0)

  useEffect(() => {
    if (!inView) return
    lastScrollY.current = window.scrollY

    function handleScroll() {
      const currentY = window.scrollY
      const delta = currentY - lastScrollY.current
      lastScrollY.current = currentY

      setShift(prev => {
        const next = prev + delta * SHIFT_STEP
        return Math.max(-SHIFT_MAX, Math.min(SHIFT_MAX, next))
      })

      clearTimeout(settleTimer.current)
      settleTimer.current = setTimeout(() => setShift(0), SETTLE_DELAY)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
      clearTimeout(settleTimer.current)
    }
  }, [inView])

  return (
      <div className="stack-grid-wrap" data-aos="fade-left" ref={sectionRef}>
          <span className="stack-grid-lines" aria-hidden="true" />
          <div className="stack-grid">
            {GRID_ROWS.map((row, rIdx) => (
              <div
                key={rIdx}
                className="stack-grid-row"
                style={{ transform: `translateX(${shift * ROW_MULTIPLIER[rIdx]}px)` }}
              >
                {row.map((cell, cIdx) =>
                  cell ? (
                    <span key={cIdx} className={`stack-grid-icon stack-grid-icon--${COL_BLUR_TIER[cIdx]}`}>
                      <span className="stack-grid-badge">
                        <cell.Icon />
                      </span>
                    </span>
                  ) : (
                    <span key={cIdx} className="stack-grid-icon stack-grid-icon--empty" />
                  )
                )}
              </div>
            ))}
          </div>
        </div>
     
    
  )
}